class MemoLinkService {
    async getAll () {
        return await axios
            .get('memo-links')
            .then((response) => {
                if (response?.name !== 'AxiosError') {
                    return response.data.data
                } else {
                    return []
                }
            })
    }

    async show (link, subdomain = null) {
        return await axios
            .get('memo-link/search', {
                params: {
                    link: link,
                    subdomain: subdomain
                }
            })
            .then((response) => {
                if (response?.name !== 'AxiosError') {
                    return response.data.data
                } else {
                    return null
                }
            })
    }
}

export function useMemoLinkService () {
    return new MemoLinkService()
}
